// extracted by mini-css-extract-plugin
export default {"layout-wrapper":"layout_layout-wrapper__Bq2q2","layout-main":"layout_layout-main__c+Du0","layout-inner":"layout_layout-inner__D3gKB"};